import { getUserKeyFromLocalStorage, withOfflineSupport } from "@/utils/v2";
import { SiteRoutes } from "./routes";
import { ApiClient } from "@/api/v2/api";
import { Site } from "@/types/v2";
import { SitesStorageService } from "./storage";

interface SitesResponse {
  status: string;
  sites: Site[];
}

export const SitesService = {
  getUserSites: withOfflineSupport(
    async () => {
      const userKey = getUserKeyFromLocalStorage();

      if (!userKey) return [];

      const url = SiteRoutes.GET_USER_SITES.replace("{key}", userKey);
      const response = await ApiClient.get<SitesResponse>(url);
      return response.data.sites;
    },
    async () => {
      return await SitesStorageService.getSites();
    }
  ),
};
